'use strict';

angular.module('app').directive('liveChatClick', function(GTM) {
    var link = function(scope, element) {
        $(element).on('click', function(e) {
            e.stopPropagation();
            console.log(111);
            $('#livechat')[0].click();


            GTM.event('booking_enquiry_chat_completed');
        });
    };
    return {
        restrict: 'A',
        link: link
    };
});